import { render, staticRenderFns } from "./pro-chiose-tabs.vue?vue&type=template&id=d4fbcf90&scoped=true";
import script from "./pro-chiose-tabs.vue?vue&type=script&lang=jsx";
export * from "./pro-chiose-tabs.vue?vue&type=script&lang=jsx";
import style0 from "./pro-chiose-tabs.vue?vue&type=style&index=0&id=d4fbcf90&prod&lang=less&scoped=true";

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, "d4fbcf90", null);
export default component.exports;